export const QueryKey = {
	GET_SESSION_CONTEXT: 'GetSessionContext',
	GET_STATUS: 'GetStatus',
	GET_SESSION_DATA: 'GetSessionData',
	GET_PROVIDERS: 'GetProviders',
	GET_CLINIC_LOCATIONS: 'GetClinicLocations',
};
